///Reasons to buy banner slideshow
var slides = document.querySelectorAll("#slides .slide-announcement");
var currentSlide = 0;
var slideInterval = setInterval(nextSlide, 3000);
if (slides){
function nextSlide() {
  slides[currentSlide].className = "slide-announcement";
  currentSlide = (currentSlide + 1) % slides.length;
  slides[currentSlide].className = "slide-announcement showing";
}
}

///Reasons to believe banner slideshow


var slides2 = document.querySelectorAll("#slides-2 .slide-ingredients");
var currentSlide2 = 0;
var slideInterval2 = setInterval(nextSlide2, 3000);

if (slides2){

function nextSlide2() {
  
  slides2[currentSlide2].className = "slide-ingredients";
  currentSlide2 = (currentSlide2 + 1) % slides2.length;
  slides2[currentSlide2].className = "slide-ingredients showing2";
 
}
}

//Slideshow with tabs as seen on 'Our Story'
//pt.1 - slide tiles:
//get slide tiles and add active class to first one on load
// add active class other ones when they are clicked
//remove active class to previously clicked titles.
//pt.2 - slides
//add active class to index corresponding slide image and text when slide title is clicked
//remove active class to last active slide when another one is clicked
const principles = document.getElementsByClassName("value");
if (principles) {
if (principles.length > 0) {
  principles[0].classList.add("active");
}
}

const mySlides = document.getElementsByClassName("mySlides");
const myHeadings = document.querySelectorAll(".values-nav .value");
if (mySlides){
if (mySlides.length > 0) mySlides[0].classList.add("active");
for (let m = 0; m < principles.length; m++) {
  principles[m].addEventListener("click", () => {
    fadeLastActive();
    closeLastActive();
    principles[m].classList.add("active");

    mySlides[m].classList.add("active");
  });
}
}
function fadeLastActive() {
  for (let n = 0; n < principles.length; n++) {
    principles[n].classList.remove("active");
  }
}

function closeLastActive() {
  for (let p = 0; p < mySlides.length; p++) {
    mySlides[p].classList.remove("active");
  }
}

//mobile
//if next control is clicked, display higher index number slide: remove active class to last active, add active class to +1 slide title & +1 slide,
//if prev control is clicked, display lower index number slide: remove active class to last active, add active class to -1 slide title & -1 slide
const next = document.querySelectorAll(
  ".slideshow-container .controls .next"
)[0];
const prev = document.querySelectorAll(
  ".slideshow-container .controls .prev"
)[0];

if (next) {
  next.addEventListener("click", () => {
    let currentActiveSl = document.querySelectorAll(".mySlides.active")[0];
    let currentHeading = document.querySelectorAll(".value.active")[0];

    // reset existing active items
    currentActiveSl.classList.remove("active");
    currentHeading.classList.remove("active");
  
    // update active slide
    if (!currentActiveSl.nextElementSibling) mySlides[0].classList.add("active");
    else currentActiveSl.nextElementSibling.classList.add("active");
  
    // update active heading
    if (!currentHeading.nextElementSibling) myHeadings[0].classList.add("active");
    else currentHeading.nextElementSibling.classList.add("active");
  });
}

if (prev) {
  prev.addEventListener("click", () => {
    let currentActiveSl = document.querySelectorAll(".mySlides.active")[0];
    let currentHeading = document.querySelectorAll(".value.active")[0];

    // reset existing active items
  	currentActiveSl.classList.remove("active");
    currentHeading.classList.remove("active");
  
    // update active slide
    if (currentActiveSl.previousElementSibling.classList.contains("controls")) {
      mySlides[mySlides.length - 1].classList.add("active");
    } else {
      currentActiveSl.previousElementSibling.classList.add("active");
    }
  
    // update active heading
    if (!currentHeading.previousElementSibling) myHeadings[myHeadings.length - 1].classList.add("active");
    else currentHeading.previousElementSibling.classList.add("active");
  });
}

function closeLastSlActive() {
  currentActiveSl.classList.remove("active");
}

function hideLastActive() {
  currentHeading.classList.remove("active");
}

function buildAccordions(titleElements) {
  /*
   * A function that builds accordions out of adjacent HTML elements
   * :param {(Node[] | NodeList)} titleElements: accordion title elements (should be adjacent to accordion content elements)
   */
  for (const accordion of titleElements) {
    accordion.addEventListener("click", function () {
      accordion.classList.toggle("active");

      // if accordion has a max height, remove it (shrink)
      // else set height to it's native height (expand)
      accordion.nextElementSibling.style.maxHeight
        ? (accordion.nextElementSibling.style.maxHeight = null)
        : (accordion.nextElementSibling.style.maxHeight =
            accordion.nextElementSibling.scrollHeight + "px");
    });
  }
}

// init mobile accordions
document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth < 769) {
    const mobileAccordions = document.getElementsByClassName(
      "accordion__title--mobile"
    );
    for (const el of mobileAccordions) {
      el.classList.add("accordion__title");
      el.nextElementSibling.classList.add("accordion__content");
    }
  }
  buildAccordions(document.getElementsByClassName("accordion__title"));
});

// quick add to cart
function addItemToCart(variantId, callback) {
  const payload = {
    items: [
      {
        quantity: 1,
        id: variantId,
      },
    ],
  };

  fetch("/cart/add.js", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  }).then((r) => {
    r.json()
      .then((data) => {
        callback(data);
      })
      .catch((error) => {
        console.log(error);
      });
  });
}

function closeCartDrawer() {
  const cartDrawer = document.getElementById("CartDrawer");
  document.getElementsByTagName("html")[0].classList.remove("js-drawer-open");
  document.getElementsByTagName("body")[0].classList.remove("js-drawer-open");
  cartDrawer.classList.remove("drawer--is-open");
  setTimeout(() => {
    cartDrawer.classList.remove("is-transitioning");
  }, 800);
}

function openCartDrawer() {
  const cartDrawer = document.getElementById("CartDrawer");

  document.getElementsByTagName("html")[0].classList.add("js-drawer-open");
  document.getElementsByTagName("body")[0].classList.add("js-drawer-open");
  cartDrawer.classList.add("is-transitioning");
  setTimeout(() => cartDrawer.classList.add("drawer--is-open"), 10);

  // init close button
  const closeBtn = cartDrawer.getElementsByClassName("js-drawer-close")[0];
  closeBtn.addEventListener("click", () => {
    closeCartDrawer();
  });

  // init close when click outside drawer
  const isVisible = (elem) =>
    !!elem &&
    !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
  const outsideClickListener = (event) => {
    if (
      !event.target.classList.contains("quick-product__btn") &&
      !event.target.classList.contains("quick-product__label") &&
      !cartDrawer.contains(event.target) &&
      isVisible(cartDrawer)
    ) {
      closeCartDrawer();
    }
  };

  const removeClickListener = () => {
    document.removeEventListener("click", outsideClickListener);
  };

  document.addEventListener("click", outsideClickListener);
}

function clearCartDrawerContents() {
  const cartDrawer = document.getElementById("CartContainer");
  while (cartDrawer.firstChild) cartDrawer.removeChild(cartDrawer.firstChild);
}

function buildCartFromTemplate(cart, handlebarsTemplate) {
  clearCartDrawerContents();

  if (cart.item_count === 0) {
    $("#CartContainer").append(
      '<div class="drawer__scrollable"><p class="appear-animation appear-delay-3"></p></div>'
    );
  } else {
    var items = [];
    var item = {};
    var data = {};
    var animation_row = 1;

    $.each(cart.items, function (index, product) {
      var prodImg;
      if (product.image !== null) {
        prodImg = product.image.replace(/(\.[^.]*)$/, "_180x$1");
      } else {
        prodImg =
          "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      if (product.properties !== null) {
        $.each(product.properties, function (key, value) {
          if (key.charAt(0) === "_" || !value) {
            delete product.properties[key];
          }
        });
      }

      // If we have line-item discount, add formattedAmount to discount object
      var amount = 0;
      if (product.line_level_discount_allocations.length !== 0) {
        for (var discount in product.line_level_discount_allocations) {
          amount = product.line_level_discount_allocations[discount].amount;

          product.line_level_discount_allocations[
            discount
          ].formattedAmount = theme.Currency.formatMoney(
            amount,
            theme.settings.moneyFormat
          );
        }
      }

      animation_row += 2;

      item = {
        key: product.key,
        url: product.url,
        img: prodImg,
        animationRow: animation_row,
        name: product.product_title,
        variation: product.variant_title,
        properties: product.properties,
        sellingPlanAllocation: product.selling_plan_allocation,
        itemQty: product.quantity,
        price: theme.Currency.formatMoney(
          product.price,
          theme.settings.moneyFormat
        ),
        unitPrice: theme.Currency.formatMoney(
          product.unit_price,
          theme.settings.moneyFormat
        ),
        unitBase: theme.Currency.getBaseUnit(product),
        discountedPrice: theme.Currency.formatMoney(
          product.price - product.total_discount / product.quantity,
          theme.settings.moneyFormat
        ),
        discounts: product.line_level_discount_allocations,
        discountsApplied:
          product.line_level_discount_allocations.length === 0 ? false : true,
        vendor: product.vendor,
      };

      console.log("ITEM TEST: ", item);

      items.push(item);
    });

    animation_row += 2;

    // If we have cart discount, add a formattedAmount to the discount object
    var cartAmount = 0;
    if (cart.cart_level_discount_applications.length !== 0) {
      for (var cartDiscount in cart.cart_level_discount_applications) {
        cartAmount =
          cart.cart_level_discount_applications[cartDiscount]
            .total_allocated_amount;

        cart.cart_level_discount_applications[
          cartDiscount
        ].formattedAmount = theme.Currency.formatMoney(
          cartAmount,
          theme.settings.moneyFormat
        );
      }
    }

    data = {
      items: items,
      note: cart.note,
      lastAnimationRow: animation_row,
      cartDiscounts: cart.cart_level_discount_applications,
      cartDiscountsApplied:
        cart.cart_level_discount_applications.length === 0 ? false : true,
      totalPrice: theme.Currency.formatMoney(
        cart.total_price,
        theme.settings.moneyFormat
      ),
    };

    $("#CartContainer").append(handlebarsTemplate(data));
  }

  $("body").trigger("updateCart.ajaxcart", cart);

  if (window.Shopify && Shopify.StorefrontExpressButtons) {
    Shopify.StorefrontExpressButtons.initialize();
  }
}

function initAjaxCartListeners(addToCartButtons) {
  const source = document.getElementById("CartTemplate").innerHTML;

  Handlebars.registerHelper('ifCond', function(v1, v2, options) {
    if(v1 === v2) {
      console.log({v1}, {v2})
      return options.fn(this);
    }
    return options.inverse(this);
  });

  let shipping_interval_unit_type = '';
  let shipping_interval_frequency = '';
  let productSubscriptionPropertise = '';
  Handlebars.registerHelper('productSubscriptionPropertise', function (option1, option2) {
    if(option1 === 'shipping_interval_unit_type'){
      shipping_interval_unit_type = option2
    }
    if(option1 === 'shipping_interval_frequency'){
      shipping_interval_frequency = option2
    }
    productSubscriptionPropertise = `${shipping_interval_frequency} ${shipping_interval_unit_type}`
    return productSubscriptionPropertise
  })

  const template = Handlebars.compile(source);

  for (const button of addToCartButtons) {
    button.addEventListener("click", (e) => {
      // add waiting symbol to ATC button
      button.classList.add("btn--loading");

      // add product to the cart
      const variantId = button.dataset.variantId;

      // rebuild cart drawer from template
      addItemToCart(variantId, () => {
        theme.cart.getCart().then(function (cart) {
          buildCartFromTemplate(cart, template);
          button.classList.remove("btn--loading");
          openCartDrawer();
        });
      });
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  // init Ajax cart where required
  // if recommended products exist, we need to wait for recommended products to load
  if (document.querySelector("[data-section-type='product-recommendations']")) {
    recommendationsObserver = new MutationObserver((mutations, observer) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.classList.contains("product-recommendations")) {
            initAjaxCartListeners(document.querySelectorAll(".quick-product__btn"));
          }
        }
      }
    });
  
    const recommendationsContainer = document.querySelectorAll("[data-section-type='product-recommendations']");
    for (const container of recommendationsContainer) {
      recommendationsObserver.observe(container.getElementsByClassName("product-recommendations-placeholder")[0], {childList: true});
    }
    
  } else {
	initAjaxCartListeners(document.querySelectorAll(".quick-product__btn"));
  }
});

// check for instagram section & implement wave overlap
document.addEventListener("DOMContentLoaded", () => {
                          
  if (document.querySelectorAll("[data-section-type='instafeed-custom']").length > 0) {
    document.getElementsByClassName("site-footer")[0].classList.add("page-has-instagram");
  };
});

// Product page tooltips
document.addEventListener("DOMContentLoaded", () => {
  const subscriptionTooltips = document.getElementsByClassName("product__subscription-tooltip");

  if (subscriptionTooltips.length > 0) {
    for (tooltip of subscriptionTooltips) {
      tooltip.getElementsByClassName("product__subscription-tooltip__trigger")[0].addEventListener("mouseover", () => {
        tooltip.getElementsByClassName("product__subscription-tooltip__content")[0].classList.add("tooltip--active");
      });
      tooltip.getElementsByClassName("product__subscription-tooltip__trigger")[0].addEventListener("mouseout", () => {
        tooltip.getElementsByClassName("product__subscription-tooltip__content")[0].classList.remove("tooltip--active");
      });
    }
  }
});

//have external links open in a new browser tab
document.addEventListener("DOMContentLoaded", () => {
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}
})




// // Create an observer instance linked to the callback function
// const observer = new MutationObserver(callback);

// // Start observing the target node for configured mutations
  
// observer.observe(targetNode, config);
  
                  
                          
 

                          
                          
                         
